const Paths = {
  Pharmacy: "/pharmacy",
  Oriola: "/oriola",
  PharmaCompany: "/pharmaCompany",
  CompensationRules: "/compensationRules",
};

export default Paths;
